/* eslint-disable react/prop-types */
import React, { CSSProperties } from "react";
import { omit } from "../../libs/utils/object";

type TypographyProps = React.HTMLAttributes<HTMLDivElement> & {
    variant?:
        | "primary"
        | "secondary"
        | "grey-1"
        | "grey-2"
        | "gray-dark"
        | "gray-dark-2"
        | "white"
        | "gray-print"
        | "gray-light-2"
        | "dimgray"
        | "darkgray"
        | "black";
    fontSize?: CSSProperties["fontSize"];
    decoration?: CSSProperties["textDecoration"];
    textAlign?: CSSProperties["textAlign"];
    as?: React.ElementType;
};

type TypographyStyle = Pick<
    CSSProperties,
    "color" | "fontSize" | "textDecoration" | "textAlign"
>;

export const Typography: React.FC<TypographyProps> = (
    props: TypographyProps
) => {
    const Component = props.as || "span";
    const rest = omit(props, ["color", "fontSize", "decoration", "textAlign"]);
    const style: TypographyStyle = {
        color: props.variant ? `var(--${props.variant})` : "",
        fontSize: props.fontSize,
        textDecoration: props.decoration,
        textAlign: props.textAlign,
    };
    return (
        <Component
            data-testid="Typography"
            {...rest}
            style={{ ...props.style, ...style }}
        >
            {props.children}
        </Component>
    );
};
